<template>
  <Icon>
    <svg :class="$style['svg-icon']" slot="svg" width="9px" height="21px" viewBox="0 0 9 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs></defs>
      <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="icons/menu_lacznik" fill="#8D99AE" fill-rule="nonzero">
          <path d="M2.5,19.5 C2.5,20.0522847 2.05228475,20.5 1.5,20.5 C0.94771525,20.5 0.5,20.0522847 0.5,19.5 L0.5,13.5 C0.5,12.9477153 0.94771525,12.5 1.5,12.5 C2.05228475,12.5 2.5,12.9477153 2.5,13.5 L2.5,19.5 Z M2.5,7.5 C2.5,8.05228475 2.05228475,8.5 1.5,8.5 C0.94771525,8.5 0.5,8.05228475 0.5,7.5 L0.5,1.5 C0.5,0.94771525 0.94771525,0.5 1.5,0.5 C2.05228475,0.5 2.5,0.94771525 2.5,1.5 L2.5,7.5 Z M1.5,20.5 C0.94771525,20.5 0.5,20.0522847 0.5,19.5 C0.5,18.9477153 0.94771525,18.5 1.5,18.5 L7.5,18.5 C8.05228475,18.5 8.5,18.9477153 8.5,19.5 C8.5,20.0522847 8.05228475,20.5 7.5,20.5 L1.5,20.5 Z" id="Combined-Shape"></path>
        </g>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "./icon";

export default {
  name: "DsSubmenuIcon",
  components: {
    Icon
  }
};
</script>
<style lang="scss" module>
.svg-icon {
  margin-left: 7px;
  margin-bottom: 2px;
  margin-top: 6px;
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-submenu-icon.vue